import React, { useEffect, useState } from 'react';

// Define the VersionInfo interface locally
interface VersionInfo {
    version: string;
    buildDate?: string;
    commitHash?: string;
}

const VersionDisplay = () => {
    const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);

    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            setVersionInfo({ version: 'DEVELOPMENT' });
            return;
        }

        fetch('/version.json')
            .then(res => res.json())
            .then(data => setVersionInfo(data))
            .catch(err => {
                console.error('Fehler beim Laden der Version:', err);
                setVersionInfo({ version: 'UNKNOWN' });
            });
    }, []);

    if (!versionInfo) return null;

    return <p style={{ margin: 0, fontSize: "inherit" }}>Version: {versionInfo.version}</p>;
};

export default VersionDisplay;
